
const OC_LIBERADA_SAP = '1'
const OC_DISPONIBLE_PROVEEDOR = '2'
const OC_A_FACTURAR = '3'
const OC_NO_DISPONIBLE_PROVEEDOR = '7'
const OC_FACTURADA = '9'

export default {
  OC_LIBERADA_SAP: OC_LIBERADA_SAP,
  OC_DISPONIBLE_PROVEEDOR: OC_DISPONIBLE_PROVEEDOR,
  OC_A_FACTURAR: OC_A_FACTURAR,
  OC_NO_DISPONIBLE_PROVEEDOR: OC_NO_DISPONIBLE_PROVEEDOR,
  OC_FACTURADA: OC_FACTURADA
}



// WEBPACK FOOTER //
// ./src/config/buy_order_status.js